import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
} from '@chakra-ui/react';
import { useState } from 'react';
import { validacionCorreo } from '../Admin/validaciones';
import { forgotEmail } from '../../services/forgotEmail';
import { useTranslation } from 'react-i18next';

export const ModalContrasena = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  const [correo, setCorreo] = useState('');
  const [message, setMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleEmail = async () => {    

    if (!correo) return;
    setIsLoading(true);
    const {
      status,
      data: { msg },
    } = await forgotEmail(correo);

    if (status === 200) {
      setMessage(msg);
    } else {
      //console.log('ERROR');
    }
    setIsLoading(false);
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      isCentered
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('FORGOT_PASSWORD')}</ModalHeader>
        <ModalBody>
          <div className="d-flex flex-column">
            <label htmlFor="correo">{t('ENTER_EMAIL')}</label>
            <input
              className="form-control my-4"
              value={correo}
              onChange={(e) => {
                if (!e.target.value.match(validacionCorreo)) {
                  return;
                }
                setCorreo(e.target.value);
              }}
            />
          </div>
          {message && (
            <div
              className="p-2 my-2 rounded text-white"
              style={{ backgroundColor: '#3b3b3b' }}
            >
              {message}
            </div>
          )}
          <Button
            colorScheme="blue"
            isDisabled={!correo || isLoading}
            onClick={handleEmail}
          >
            {t('SEND')}
          </Button>
        </ModalBody>
        <ModalFooter>
          <Button
            colorScheme="red"
            mr={3}
            onClick={onClose}
            isDisabled={isLoading}
          >
            {t('CLOSE')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
